export const data: any = {
  NEXT_PUBLIC_DEPLOYMENT_ENV: "development",
  NEXT_PUBLIC_BASE_URL: "https://marketplace.trimble.com",
  NEXT_PUBLIC_SITEMAP_BASE_URL: "https://marketplace.trimble.com",
  NEXT_PUBLIC_SITE_MACHINE_NAME: "marketplace",
  NEXT_PUBLIC_CF_MXP_SPACE_ID: "rerp0bq2ntu3",
}
